export default __webpack_public_path__ + "static/media/ninjaondemand-logo.5ac2a4ce.png";